import { render, staticRenderFns } from "./DownlineApproval.vue?vue&type=template&id=0817e5f7&"
import script from "./DownlineApproval.vue?vue&type=script&lang=js&"
export * from "./DownlineApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports